export const TYPES = {
  all: 'all',
  one: 'one',
};

export const APPEARANCES = {
  default: 'default',
  grey: 'grey',
};
